import React, { useEffect, useState } from "react";
import "./styles/PlanSelection.css";
import PricePlans from "../../assets/images/pricePlans.jpg"
import Tick from "../../assets/icons/svgs/tick.svg";
import {
  PrimaryBtn,
  RectBtn,
  SectionHeading1,
  SectionTitle,
} from "../../components/BasicComponents";
import { Link } from "react-router-dom";
import PlanCard from "../../components/PlanCard";
import instance from "../../axios";
import { getUserToken, setUserToken } from "../../utils/userAuthenticate";
import { createPortal } from "react-dom";
import Toast from "../../components/Toast";
import useUserAuthentication from "../../hooks/useUserAuthentication";
import CustomPlanCard from "../../components/CustomPlanCard";

import { BsCheck2, BsXLg } from "react-icons/bs";
import { useTranslation, Trans } from "react-i18next";
import "../../localisation/index"

const PlanSelection = () => {
  const appName = process.env.REACT_APP_NAME
  const {t} = useTranslation()
  const tableContent = [
    {
      title: t("planSelection.plansList.title1"),
      basic: true,
      pro: true,
      premium: true,
      enterprise: true,
    },
    {
      title: t("planSelection.plansList.title2"),
      basic: true,
      pro: true,
      premium: true,
      enterprise: true,
    },
    {
      title: t("planSelection.plansList.title3"),
      basic: false,
      pro: false,
      premium: false,
      enterprise: true,
    },
    {
      title: t("planSelection.plansList.title4"),
      basic: true,
      pro: true,
      premium: true,
      enterprise: true,
    },
    {
      title: t("planSelection.plansList.title5"),
      basic: false,
      pro: false,
      premium: false,
      enterprise: true,
    },
    {
      title: t("planSelection.plansList.title6"),
      basic: false,
      pro: false,
      premium: false,
      enterprise: true,
    },
    {
      title: t("planSelection.plansList.title7"),
      basic: false,
      pro: false,
      premium: false,
      enterprise: true,
    },

    {
      title: t("planSelection.plansList.title8"),
      basic: true,
      pro: true,
      premium: true,
      enterprise: true,
    },
    {
      title: t("planSelection.plansList.title9"),
      basic: false,
      pro: false,
      premium: false,
      enterprise: true,
    },
    {
      title: t("planSelection.plansList.title10"),
      basic: false,
      pro: false,
      premium: false,
      enterprise: true,
    },
    {
      title: t("planSelection.plansList.title11"),
      basic: false,
      pro: false,
      premium: false,
      enterprise: true,
    },
    {
      title: t("planSelection.plansList.title12"),
      basic: false,
      pro: false,
      premium: false,
      enterprise: true,
    },
    {
      title: t("planSelection.plansList.title13"),
      basic: false,
      pro: false,
      premium: false,
      enterprise: true,
    },
  ];

  const [isError, setIsError] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [plans, setPlans] = useState(null);
  const [isAgree, setIsAgree] = useState(false);
  const [terms, setTerms] = useState(false);

  const [reponsePaymentData, setReponsePaymentData] = useState();

  // get plans
  const fetchPlan = async () => {
    const url = "/plan/list";
    const headers = {
      Authorization: getUserToken(),
    };

    try {
      const res = await instance.post(url, {}, { headers });
      const resData = res.data;
      if (resData?.code === 401) {
        throw new Error(t("errors.authenticationError"));
      }
      if (resData?.code === 403) {
        throw new Error(t("errors.sessionError"));
      }

      // for any other error
      if (resData?.code !== 200) {
        throw new Error(t("planSelection.networkError"));
      }

      setPlans(res.data);

      // const scPlan
      const scPlan = res.data.data.selectedPlan;
      const crPlan = res.data.data.plans.find(
        (item) => item.plan_name?.toLowerCase() === scPlan?.toLowerCase()
      );
      setSelectedPlan(crPlan);
    } catch (error) {
      console.log(error);
      setIsError(error.message);
    }
  };

  console.log(isAgree);

  // handle confirm payment
  const handleCnfPayment = async () => {
    if (!isAgree) {
      alert(t("planSelection.alert"));
      return;
    }

    // payment process
    const url = "/payment/create";
    const headers = {
      Authorization: getUserToken(),
    };
    const body = {
      plan_name:
        selectedPlan.plan_name.slice(0, 1).toUpperCase() +
        selectedPlan.plan_name.slice(1),
    };

    try {
      const res = await instance.post(url, body, { headers });
      const resData = res.data;
      console.log(resData);
      setReponsePaymentData(resData.data);
    } catch (error) {
      console.log(error);
    }

    console.log("after");
  };

  // if token then set
  useUserAuthentication();

  useEffect(() => {
    fetchPlan();
  }, []);

  if (isError) {
    return <Toast>{isError}</Toast>;
  }
  return (
    <div className="plan-selection-container container_padding">
      {/* show terms and condition */}
      {terms &&
        createPortal(
          <TermsPopUp setTerms={setTerms} t={t} />,
          document.getElementById("portal")
        )}
      {/* payment confirm message */}
      {reponsePaymentData &&
        createPortal(
          <PaymentConfirmPopup
            reponsePaymentData={reponsePaymentData}
            setReponsePaymentData={setReponsePaymentData}
            appName={appName}
            t={t}
          />,
          document.getElementById("portal")
        )}
      <div className="section-box-container">
        <SectionHeading1
          size="20px"
          weight="600"
          lineheight="20px"
          align="center"
          margin="0px 0px"
        >
          {t("planSelection.issuance")}
        </SectionHeading1>
      </div>
      {/* plans */}
      <div className="package-detail">
        {t("planSelection.select")}
        {/* <RectBtn
          border=" "
          width="100%"
          height="45px"
          weight="400"
          active={true}
        ></RectBtn> */}
      </div>
      <div className="plans">
        {plans?.data.plans.sort((a,b)=>a.price-b.price).map((plan, index) => {
          return (
            <PlanCard
              key={index}
              plan={plan}
              popular={plan?.plan_name === "Pro" ? true : false}
              btnText={"Select"}
              active={
                selectedPlan?.plan_name?.toLowerCase() ===
                plan?.plan_name?.toLowerCase()
                  ? true
                  : false
              }
              setPlan={setSelectedPlan}
            />
          );
        })}

        <CustomPlanCard
          plan={{ plan_name: t("planSelection.enterprise") }}
          btnText={t("planSelection.contact")}
        />
      </div>
      <div className="section-box-container">
        <div className="terms-check">
          <input
            type="checkbox"
            onChange={(e) => {
              e.stopPropagation();
              console.log(">>", e.target.checked);
              !!e.target.checked ? setIsAgree(true) : setIsAgree(false);
            }}
          />
            {t("planSelection.accept", { appName })}
          <Link onClick={() => setTerms(true)}>{t("commonTexts.terms")}</Link>
        </div>
      </div>
      <div style={{ margin: "40px 0px" }}>
        <PrimaryBtn $primary onClick={handleCnfPayment}>
          {t("planSelection.pay")}
        </PrimaryBtn>
      </div>

      <SectionHeading1
        size="20px"
        weight="500"
        lineheight="20px"
        align="center"
        margin="35px 0px"
      >
        {t("planSelection.compare", {appName})}
      </SectionHeading1>
      {/* plan table */}
      <table className="plan-table">
        <thead>
          <tr>
            <th>{t("planSelection.table.features")}</th>
            <th>{t("planSelection.table.basic")}</th>
            <th>{t("planSelection.table.pro")}</th>
            <th>{t("planSelection.table.premium")}</th>
            <th>{t("planSelection.table.enterprise")}</th>
          </tr>
        </thead>
        <tbody>
          {tableContent.map((rowData, index) => {
            return (
              <tr key={index}>
                <td>{rowData.title}</td>
                <td>
                  {rowData.basic ? (
                    <BsCheck2 className="plan-check" />
                  ) : (
                    <span className="dash"></span>
                  )}
                </td>
                <td>
                  {rowData.pro ? (
                    <BsCheck2 className="plan-check" />
                  ) : (
                    <span className="dash"></span>
                  )}
                </td>
                <td>
                  {rowData.premium ? (
                    <BsCheck2 className="plan-check" />
                  ) : (
                    <span className="dash"></span>
                  )}
                </td>
                <td>
                  {rowData.enterprise ? (
                    <BsCheck2 className="plan-check" />
                  ) : (
                    <span className="dash"></span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="plan-table__note">{t("planSelection.note")}</div>
    </div>
  );
};

export default PlanSelection;

// terms and condition popup
const TermsPopUp = ({ setTerms, t }) => {
  return (
   <div className="terms-pop__container">
<div className="component">
      <div className="section-box-container">
        <h2 className="">{t("planSelection.terms.title")}</h2>
      </div>
      <div className="agreement-component">
        <div className="agreement-component_content">
          <div>
            <ol type="1">
              <li>
                <Trans i18nKey="planSelection.terms.bullet1" components={{b: <b />}} />
              </li>
              <li>
                {t("planSelection.terms.bullet2")}
              </li>
              <li>
                  <Trans i18nKey="planSelection.terms.bullet3" components={{b: <b />}} />
              </li>
              <li>
                  {t("planSelection.terms.bullet4")}
              </li>
              <li>{t("planSelection.terms.bullet5")}</li>
              <li>{t("planSelection.terms.bullet6")}</li>
              <li>{t("planSelection.terms.bullet7")}</li>
              <li><Trans i18nKey="planSelection.terms.bullet8" components={{b: <b />}} /></li>
              <li>{t("planSelection.terms.bullet9")}</li>
              <li>{t("planSelection.terms.bullet10")}</li>
              <li>{t("planSelection.terms.bullet11")}</li>
              <li>{t("planSelection.terms.bullet12")}</li>
              <li>
                <Trans i18nKey="planSelection.terms.bullet13" components={{ b: <strong /> }} />
              </li>
              <li>
                <Trans i18nKey="planSelection.terms.bullet14" components={{ b: <strong /> }} />
              </li>
              <li>
                <Trans i18nKey="planSelection.terms.bullet15" components={{ b: <strong /> }} />
              </li>
              <li>
                <Trans i18nKey="planSelection.terms.bullet16" components={{ b: <strong /> }} />
              </li>
            </ol>
          </div>
          <div>
            <Trans i18nKey="planSelection.terms.annexureA" components={{h1: <h1 />, div: <div />, p: <p />, h2: <h2 />, ol: <ol />, li: <li /> }} />
          </div>  
          <Trans i18nKey="planSelection.terms.annexureB" components={{h1: <h1 />, div: <div />, p: <p />, h2: <h2 />, h3: <h3 />, ol: <ol />, li: <li />, img: <img /> }} values={{
              imagePlaceholder: `<img src="${PricePlans}" alt="Price Plans" />`
            }}
          />
          <Trans i18nKey="planSelection.terms.exhibitA" components={{h1: <h1 />, div: <div />, p: <p />, h2: <h2 />, ol: <ol />, li: <li /> }} />
        </div>
      </div>
    </div>
    <PrimaryBtn onClick={() => setTerms(false)}>{t("planSelection.close")}</PrimaryBtn>
   </div>

  );
};

// payment confirm popup
const PaymentConfirmPopup = ({ reponsePaymentData, setReponsePaymentData, appName, t }) => {
  const handleFormSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission
    const form = event.target;
    const url = reponsePaymentData?.url;
    const formData = new FormData(form);

    // Convert form data to URL-encoded string
    const params = new URLSearchParams();
    for (const pair of formData.entries()) {
      params.append(pair[0], pair[1]);
    }

    // Redirect to the URL with form data
    window.location.href = `${url}?${params.toString()}`;
  };

  return (
    <div className="payment-confirm-popup">
      <div className="payment-form">
        <div className="payment-confirm-msg">
          {t("planSelection.confirmation", {appName})}
        </div>

        <div className="payment-confirm-btns">
          <form onSubmit={handleFormSubmit}>
            {reponsePaymentData?.payload &&
              Object.keys(reponsePaymentData?.payload).map((item, index) => {
                // console.log(item);
                // return item === "key" ? (
                //   <input name={"key"} value={"Ayuils"} type="hidden" />
                // ) : (
                return (
                  <input
                    key={index}
                    name={item}
                    value={reponsePaymentData?.payload[item]}
                    type="hidden"
                  />
                );
                // );
              })}

            <input type="submit" className="payment-btn" value={t("planSelection.yes")} />
          </form>
          <div
            className="payment-btn"
            onClick={() => setReponsePaymentData(false)}
          >
            {t("planSelection.no")}
          </div>
        </div>
      </div>
    </div>
  );
};
